module.exports = __webpack_public_path__ + "img/tasks-reviews-icon-v2.3a443efe.svg";